export function comparisonOptions(properties = []) {
  const values = key => {
    const raw = properties?.find(property => property.key === key)?.value;
    return [...new Set(String(raw || '').split(',').map(Number).filter(value => Number.isFinite(value) && value > 0))].sort((a, b) => a - b);
  };
  return { days: values('PackageWeeklyDay'), minutes: values('PackageDuration'), months: values('PackageMonth').filter(month => [3, 6, 12].includes(month)) };
}

export function comparisonCard(month, data) {
  const total = data?.prices?.find(price => Number(price.installmentNumber) === 1)?.total;
  const lessonCount = data?.packageProperty?.lessonCount;
  const available = !!data?.id && typeof total === 'number' && Number.isFinite(total) && total > 0 && Number.isInteger(lessonCount) && lessonCount > 0;
  return { month, available, id: data?.id, total, lessonCount, perLesson: available ? total / lessonCount : null, postpone: data?.packageProperty?.postpone, freeze: data?.packageProperty?.freezeLesson };
}
